import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { PRODUCT_TYPE } from '@common/constants/products';
import Accordion from '@common/components/Accordion';
import HTMLRenderer from '@common/components/CMSComponents/HTMLRenderer';
import { productAllTypesShape } from '@common/types/product';
import { SectionTitle } from '@common/components/ProductComponents/Content/Content.styled';

import {
  AccordionWrapper,
  ProductDescription,
  SectionDescription,
  SectionDescriptionTitle,
} from './DescriptionAccordion.styled';

// https://github.com/facebook/react/issues/19901 - paragraphs causing hydration mismatch
export const DescriptionAccordion = ({
  product: { description, material, washingInstructions },
  productType,
  noBottomSpacing,
}) => {
  const { t } = useTranslation();
  const hasDescription = !!description || !!material || !!washingInstructions;

  return hasDescription ? (
    <AccordionWrapper noBottomSpacing={noBottomSpacing}>
      <Accordion
        noBottomDivider={noBottomSpacing}
        isFirstItem
        titleComponent={
          <SectionDescriptionTitle>
            {t('productDetails.additionalInfo.title', 'Weitere Infos')}
          </SectionDescriptionTitle>
        }
      >
        {!!description && (
          <ProductDescription customAs="div">
            <HTMLRenderer
              data-testid="productDescription"
              customAs="span"
              // https://github.com/facebook/react/issues/19901 - paragraphs causing hydration mismatch
              html={description}
              nl2br
            />
          </ProductDescription>
        )}

        {productType === PRODUCT_TYPE.SHOP_EVENT && !!material && (
          <>
            <SectionTitle>
              {t('productDetails.material', 'Material')}
            </SectionTitle>
            <SectionDescription>
              {material.replace(/\\n/g, '\n')}
            </SectionDescription>
          </>
        )}

        {!!washingInstructions && (
          <>
            <SectionTitle>
              {t('productDetails.washingInstructions', 'Waschanweisung')}
            </SectionTitle>
            <SectionDescription>{washingInstructions}</SectionDescription>
          </>
        )}
      </Accordion>
    </AccordionWrapper>
  ) : null;
};

DescriptionAccordion.propTypes = {
  product: productAllTypesShape.isRequired,
  noBottomSpacing: PropTypes.bool,
  productType: PropTypes.oneOf([PRODUCT_TYPE.DEFAULT, PRODUCT_TYPE.SHOP_EVENT])
    .isRequired,
};

DescriptionAccordion.defaultProps = {
  noBottomSpacing: false,
};

export default DescriptionAccordion;
